export default __webpack_public_path__ + "static/media/41.29d1d732.svg";